function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { css } from '@emotion/react';
import { contrastingTextColor, nameToHash, su } from '@arc/frontend/ui-theme';
import { getInitials } from '@arc/shared/util-formatting';
const sizes = {
  regular: {
    container: process.env.NODE_ENV === "production" ? {
      name: "1n5jvhm",
      styles: "width:2rem;height:2rem"
    } : {
      name: "1c9nier-container",
      styles: "width:2rem;height:2rem;label:container;",
      toString: _EMOTION_STRINGIFIED_CSS_ERROR__
    },
    text: process.env.NODE_ENV === "production" ? {
      name: "1u7pwvo",
      styles: "font-size:0.9rem"
    } : {
      name: "vgbri0-text",
      styles: "font-size:0.9rem;label:text;",
      toString: _EMOTION_STRINGIFIED_CSS_ERROR__
    }
  },
  small: {
    container: process.env.NODE_ENV === "production" ? {
      name: "11v5qdi",
      styles: "width:1.5rem;height:1.5rem"
    } : {
      name: "p89u5r-container",
      styles: "width:1.5rem;height:1.5rem;label:container;",
      toString: _EMOTION_STRINGIFIED_CSS_ERROR__
    },
    text: /*#__PURE__*/css(su.textXs, process.env.NODE_ENV === "production" ? "" : ";label:text;")
  }
};
export function Avatar({
  name,
  initials = getInitials(name),
  size = 'regular'
}) {
  const backgroundColor = nameToHash(name);
  const textColor = contrastingTextColor(backgroundColor);
  return <div css={[{
    backgroundColor
  }, su.roundedFull, "display:flex;align-items:center;justify-content:center;flex-shrink:0;", sizes[size].container, process.env.NODE_ENV === "production" ? "" : ";label:Avatar;"]}>
			<p css={[{
      color: textColor
    }, sizes[size].text, "font-style:normal;" + (process.env.NODE_ENV === "production" ? "" : ";label:Avatar;")]}>
				{initials}
			</p>
		</div>;
}